<template>
  <div class="shop_badges">
    <div class="shop_badge">
      <TooltipPlugin 
        tooltipText="Son 1 ay içindeki siparişlerinizi en fazla 2 iş günü içinde gönderdiğinizde bu etiketi kazanırsınız!"
        :tooltipWidth="250"
      >
        <template #tooltip-btn>
          <img
            class="fast-seller-badge"
            v-if="isFastSellerBadgeActive"
            src="@/assets/images/fast-seller-badge.svg"
            alt="Hızlı Gönderim"
          />
          <img
            class="fast-seller-badge"
            v-else
            src="@/assets/images/fast-seller-badge-disabled.svg"
            alt="Hızlı Gönderim Kapalı"
          />
        </template>
      </TooltipPlugin>
      <div class="description">Hızlı Gönderim</div>
    </div>
    <div class="shop_badge">
      <TooltipPlugin 
        tooltipText="Siparişleri 1 iş günü içinde göndererek, düzenli satışlarla ve yüksek mağaza puanına sahip olduğunuzda bu etiket sizin olur!"
        :tooltipWidth="250"
      >
      <template #tooltip-btn>
        <img v-if="isTopSellerBadgeActive" src="@/assets/images/top-seller-badge.svg" />
        <img v-else src="@/assets/images/top-seller-badge-disabled.svg" />
      </template>
      </TooltipPlugin>
      <div class="description">Başarılı Mağaza</div>
    </div>
  </div>
</template>

<script>
import { TooltipPlugin } from '@n11/so-ui-components';
export default {
  name: 'Badge',
  components: {
    TooltipPlugin,
  },
  props: {
    isFastSellerBadgeActive: {
      type: Boolean,
      default: false,
      required: true,
    },
    isTopSellerBadgeActive: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/styles/variables.scss';

.shop_badges {
  display: flex;
  gap:16px;
}
.shop_badge {
  display: flex;
  align-items: center;
  
  img {
    width: 30px;
    height: 30px;
    cursor: pointer;
    border-radius: 50%;
    border:0.5px solid $colorD30;
    margin: 0 8px 0 0;
    padding: 6px;
  }

  .description {
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 16px;
    color:#7382A0;
    white-space: nowrap;
  }
}
</style>